import { isDanish } from '../utils/url'
import { BACKEND_URL } from '../utils/settings'
const RenderPendix = () => {
  const imgUrl = isDanish
    ? `${BACKEND_URL}/images/logos/pendixinfodk.png`
    : `${BACKEND_URL}/images/logos/pendixinfo.png`

  return (
    <div className="pendix-info">
      <img src={imgUrl} alt="info" />
    </div>
  )
}

export default RenderPendix
